import type { IModalConfig, TModalConfig } from '~/interfaces/content/modals';
import {
  LazyAccountHistoryAssignBonusModal,
  LazyAccountHistoryTransactionSummaryFilter,
  LazyAccountTellerWithdrawalAlert,
  LazyUserBalances,
} from '#components';
import { InformationCircleIcon } from '@heroicons/vue/24/outline';
import { ExclamationIcon } from '~/components/design-system/icons';

interface IBankingModalConfig extends IModalConfig {
  displayBalanceToggle?: boolean;
  displayRefreshBalance?: boolean;
  displayCashBalance?: boolean;
  displayBonusBalance?: boolean;
  displayRewardsBalance?: boolean;
  displayDepositButton?: boolean;
  stretch?: boolean;
  hideCompleteAccount?: boolean;
}

export const getTellerModals = (): TModalConfig => {
  const { $enabled } = useNuxtApp();
  return {
    accountBalances: {
      modalProps: {
        title: 'account-balances',
      },
      contentProps: {
        displayBalanceToggle: true,
        displayRefreshBalance: true,
        displayCashBalance: true,
        displayBonusBalance: true,
        displayRewardsBalance: true,
        displayDepositButton: true,
        depositButtonStyle: 'modal',
        backgroundColor: 'bg-base',
        stretch: false,
        class: 'w-full p-4',
        hideCompleteAccount: $enabled('myaccount.enablepartialreg'),
      },
      component: () => LazyUserBalances,
    } as IBankingModalConfig,
    transactionAssignBonus: {
      modalProps: {
        title: 'jpc-assign-bonus-header',
        headerIcon: InformationCircleIcon,
        headerIconClass: 'text-gold-500 w-6 h-6',
      },
      component: () => LazyAccountHistoryAssignBonusModal,
    } as IBankingModalConfig,
    transactionsFilter: {
      modalProps: {
        title: 'filter-transaction-summary',
        size: 'sm',
      },
      component: () => LazyAccountHistoryTransactionSummaryFilter,
    } as IBankingModalConfig,
    withdrawalAlert: {
      modalProps: {
        title: 'withdrawal-alert',
        headerIcon: ExclamationIcon,
        headerIconClass: 'text-gold-500 w-6 h-6',
        iconTooltip: 'bonus-wallet-warning-tooltip',
        type: 'secondary'
      },
      component: () => LazyAccountTellerWithdrawalAlert,
    },
  } as const satisfies TModalConfig;
};
